module.exports = __webpack_public_path__ + "static/media/sy_for_dummies.c32dd039.jpeg";